import React from 'react';

const STEPS = [
    { t: 'Book a 30-min onboarding call', d: 'We create your free account, give you dummy data, and walk you through the platform.' },
    { t: 'Add your clients to free tier', d: 'You can add your clients for free, first create demonstrable value with no proprietary data, and then invite them in.' },
    { t: 'Quickly show value', d: "Platform design to show how it will support you in demonstrating increased value add to your clients." },
    { t: 'Find new clients', d: 'And then through AdvisorMatch, you are promoted to new clients looking for advisors.' },
];

const FractionalProcessSection = () => (
    <section id="process" className="lp-process">
        <div className="lp-container">
            <h2 className="lp-process-head" data-lp-reveal>How it works.</h2>
            <div className="lp-steps">
                <div className="lp-steps-line" aria-hidden="true" />
                {STEPS.map((s, i) => (
                    <div className="lp-step" key={i} data-lp-reveal data-lp-delay={i * 100}>
                        <div className="n">{i + 1}</div>
                        <div>
                            <h3>{s.t}</h3>
                            <p>{s.d}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default FractionalProcessSection;
